export const getGoogleTranslatedUrl = (url: string, from: string, to: string) => {
  const removedHttp = url.replace(/^https?:\/\//, "");

  const replacedDotsWithDash = removedHttp.replace(/\./g, "-");
  const domain = replacedDotsWithDash.slice(0, replacedDotsWithDash.indexOf("/"));
  const restUrl = replacedDotsWithDash.slice(replacedDotsWithDash.indexOf("/") + 1);

  return `https://${domain}.translate.goog/${restUrl}?_x_tr_sl=${from}&_x_tr_tl=${to}&_x_tr_pto=wapp`;
};
